import {IWishlistState} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {addToWishlist, getWishlist, removeFromWishlist} from "./ActionCreators";
import {IWish, WishStatus} from "../wish/Helper";

const initialValue: IWishlistState = {
    loading: false,
    items: []
}

const wishlistSlice = createSlice({
    name: SliceNames.WISHLIST,
    initialState: initialValue,
    reducers: {
        checkWishToRemove: (state, action: PayloadAction<IWish>) => {
            state.items = [...state.items].filter((w) => {
                if (action.payload.id === w.id && action.payload.status === WishStatus.FINISHED) {
                    return false
                }
                return true
            }).map((w) => {
                if (action.payload.id === w.id) return action.payload
                return w
            })
        },
        removeWishFromWishlist: (state, action: PayloadAction<string>) => {
            state.items = [...state.items].filter((w) => w.id !== action.payload)
        }
    },
    extraReducers: builder => {
        builder.addCase(
            getWishlist.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getWishlist.fulfilled, (state, action: PayloadAction<IWish[]>) => {
                    state.loading = false
                    state.items = action.payload
                })
            .addCase(
                getWishlist.rejected, (state) => {
                    state.loading = false
                })
            .addCase(
                addToWishlist.fulfilled, (state, action: PayloadAction<IWish>) => {
                    state.items = [...state.items, action.payload]
                })
            .addCase(
                removeFromWishlist.fulfilled, (state, action: PayloadAction<string>) => {
                    state.items = state.items.filter((w) => w.id !== action.payload)
                })
    }
})

export default wishlistSlice.reducer
export const {checkWishToRemove, removeWishFromWishlist} = wishlistSlice.actions